window.onload = function() {
    let toggle = document.getElementById('toggleSidebarMobile');
    if (toggle != null) {
        toggle.addEventListener('click',function(e) {
            let sideBar = document.getElementById('aside_bar');
            if (sideBar !== null) {
                if (sideBar.style.display == 'flex') {
                    sideBar.style.display = 'none';
                } else {
                    sideBar.style.display = "flex";
                }
            }
        })
    }
}
